import Logo from '../../../assets/images/gotrip-logo.webp'

const GoTripLogo = Logo

export default GoTripLogo
